/**
 * Copy compartido para la página Acerca de (estilo editorial tipo Netflix About).
 * Mantener alineado con tnonetwork/src/content/aboutTnoNetwork.ts
 */
export const aboutTnoNetworkContent = {
  heroLines: [
    'Nuestro propósito',
    'es conectar marcas y audiencias',
    'con contenido que informa,',
    'agrega valor y abre conversación',
    'en vivo, on-demand y en TNO Digest.',
  ],
  subheadline: 'Agregar valor, atraer con contenido útil y convertir confianza — una y otra vez.',
  intro:
    'Para cada rubro y cada etapa del recorrido, TNO Network combina programas en vivo, On-Demand, podcasts y TNO Digest con un enfoque de marketing inbound: contenido que educa, posiciona tu marca y nutre la relación antes del cierre comercial. Radio visual, streaming y editorial con autoridad y SEO en un solo ecosistema desde 2014.',
  throughLabel: 'Lo hacemos a través de:',
  stats: [
    { value: '2014', label: 'Año de fundación' },
    { value: '25+', label: 'Programas en vivo / semana' },
    { value: '40+', label: 'Producciones On-Demand' },
  ],
  pillars: [
    {
      title: 'Alcance',
      illustration: 'reach',
      accent: '#1565c0',
      accentLight: '#e3f2fd',
      body:
        'Llegamos a audiencias en múltiples países y formatos: más de 25 programas en la parrilla semanal, 40+ producciones On-Demand en Media Lab, presencia en redes y visitas mensuales en tnonetwork.com. Contenido que atrae tráfico y visibilidad orgánica, no solo impresiones pagadas.',
    },
    {
      title: 'Ecosistema multiplataforma',
      illustration: 'ecosystem',
      accent: '#6a1b9a',
      accentLight: '#f3e5f5',
      body:
        'TNO Live para notoriedad y recordación, On-Demand para profundizar el mensaje, TNO Digest para autoridad editorial, SEO y captación de interés, y el Media Kit para alinear inventario y narrativa inbound. Un embudo de contenido conectado, no piezas sueltas.',
    },
    {
      title: 'Comunidad y marcas aliadas',
      illustration: 'community',
      accent: '#c2185b',
      accentLight: '#fce4ec',
      body:
        'Cuando el contenido aporta utilidad — en antena, en artículos, en redes o en sala comercial — la marca deja de interrumpir y empieza a acompañar: genera confianza, recomendación y oportunidades de negocio con enfoque inbound.',
    },
  ],
  ctaGrilla: 'Explorar la grilla por nichos',
  ctaMediaKit: 'Media kit comercial',
};

export default aboutTnoNetworkContent;
